<div class="w-60">
    <app-select
        [canClear]="false"
        [defaultValue]="getDefaultValue()"
        [options]="options()"
        [placeholder]="'selectLayer'"
        (optionSelected)="changeLayer($event)" />
</div>
